import { useQuery } from "@tanstack/react-query";
import { getProgramBookingPaidAndRefundWebByProgramBookingId } from "../../../../../../../service/program";

const useGetProgramBookingPaidAndRefundWebByProgramBookingId = <T,>(id: number, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getProgramBookingPaidAndRefundWebByProgramBookingId', id, responseQuery],
        queryFn: () => getProgramBookingPaidAndRefundWebByProgramBookingId<T>(id, responseQuery),
        enabled: !!id,
        select: res => res.data.data.getProgramBookingPaidAndRefundWebByProgramBookingId,
    });

    return query;
}

export { useGetProgramBookingPaidAndRefundWebByProgramBookingId }